import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import './appLayout.css';
import Header from '../Components/Header/Header';
import Footer from '../Components/Footer/Footer';

const UserLayout = ({ redirectPath = null, variant = 'home-header' }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (redirectPath) {
      return navigate(redirectPath);
    }
  }, [redirectPath]);

  return (
    <>
      <Header variant={variant} />
      <Outlet />
      <Footer variant={variant} />
    </>
  );
};

export default UserLayout;
